import { useContext, useEffect } from 'react'
import * as _ from 'lodash-es'
import { GameContext } from '../GameContextF.jsx'
import { useAction } from '../useAction.js'
import { objHash } from '../../../sharedF/objHashF.mts'
import { CanvasGameDraw } from '../CanvasGameDrawF.jsx'
import { useLocalStorage } from '../../../componentsF/localStorageF/LocalStorWrapF.tsx'
import { PtBtn, Ptext} from '../../../componentsF/Chakra3F/ChakraF.jsx'
import { useAutoSubmit } from './useAutoSubmitAI.jsx'

export const DrawDescription = () => {
  const {myState} = useContext(GameContext)

  const {taskPrompt, assignedStackName} = myState

  // const [finishedTrails, setFinishedTrails] = useState([])
  // useLocalStorage attempts to prevent drawing loss from pull down refresh
  const [myTrailsByStackH, setMyTrailsByStackH] = useLocalStorage('myTrailsByStackH', {})
  const finishedTrails = myTrailsByStackH[assignedStackName] || []
  const setFinishedTrails = (trailsH) => {
    setMyTrailsByStackH({[assignedStackName]: trailsH})
  }

  const {doAction: onClick, loading} = useAction({
    onCompleted: () => setFinishedTrails([]),
    playerAction: 'submitDrawing', finishedTrails,
    assignedStackName,
  })
  
  useAutoSubmit({ hasContent: finishedTrails.length > 0, doSubmit: onClick })

  useEffect(() => {
    window.scrollTo({ top: 0 })
    return () => {}
  }, [objHash(taskPrompt)])

  return <>
    <Ptext {...{fontSize: '3xl'}}>
      Please draw:
    </Ptext>
    <Ptext {...{fontSize: '2xl'}}>
      {taskPrompt}
    </Ptext>
    <Ptext {...{my: 4, fontSize: 'sm'}}>
      Rules: no drawing words, letters, or numbers!
    </Ptext>
    <div data-testid="drawing-canvas">
      <CanvasGameDraw key={objHash(taskPrompt)} {...{finishedTrails, setFinishedTrails}} />
    </div>
    <PtBtn {...{'data-testid': 'submit-drawing-btn', onClick, colorScheme: 'green', mt: 8, mb: 20, fontSize: '2xl', isLoading: loading}}>
      Submit
    </PtBtn>
  </>
}